import React from 'react';

import { Paragraph1 } from 'inpock-ui-react';

import { Icon } from '../Icon';

import * as S from './styled';

interface PageTitleProps {
  title: string;
  rightSideNode?: React.ReactNode;
  borderBottom?: boolean;
  top?: number;
  onClick?: () => void;
  noIcon?: boolean;
}

export function PageTitle({
  title,
  rightSideNode,
  borderBottom,
  top,
  onClick,
  noIcon,
}: PageTitleProps) {
  return (
    <S.PageTitleContainer borderBottom={borderBottom} top={top}>
      {!noIcon && (
        <div className="icon-container">
          <Icon
            icon="ArrowBack"
            size={24}
            color="#343434"
            onClick={onClick ? onClick : () => window.history.back()}
          />
        </div>
      )}
      <Paragraph1>{title}</Paragraph1>
      {rightSideNode && <div className="right-side">{rightSideNode}</div>}
    </S.PageTitleContainer>
  );
}
